<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form name="assign-form">
        <div class="grid">
            <FormSelect fieldName="project_id"
                        label="Project"
                        size="10"
                        :options="select?.projects_with_preselected"
                        v-model:field="project_id" />

            <FormInputNumber fieldName="assign_quote"
                             label="Amount"
                             size="2"
                             :minFractionDigits="2"
                             :maxFractionDigits="2"
                             v-model:field="assign_quote" />
        </div>
        <div class="grid">
            <Button severity="success"
                    style="margin:0 8px"
                    @click="makeImport"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-solid fa-file-code"></i><span>{{ __('Assign quote to project') }}</span></template>
            </Button>
            <Button severity="secondary"
                    style="margin:0 8px"
                    @click="cancelImport"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import FormSelect from '@pages/Crud/FormSelect.vue'
import FormInputNumber from '@pages/Crud/FormInputNumber.vue'
import Button from 'primevue/button';
import { __, buttonClass, screenMessage } from '@pages/Helper/utils.js'
import { prepareSelect, onErrorService } from '@helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    formData: Object,
})

const page = usePage()
const isLoading = ref(false);
const project_id = ref(null)
const amount_to_assign = ref(null)
const already_assigned = ref(null)
const assign_quote = ref(null)
const isQuoteAssignModalOpen = defineModel('isQuoteAssignModalOpen')
const select = ref(null);


// -----------------------------------------------------

onMounted(async () => {
    select.value = await prepareSelect(['projects_with_preselected'], null, null, { 'projects_with_preselected': { contractor_name: props.formData.contractor_name } })
    amount_to_assign.value = Number(String(props.formData.amount).replace(/\s/g, '').replace(',', '.'))
    already_assigned.value = Number(String(props.formData.assigned_to_projects).replace(/\s/g, '').replace(',', '.'))
    assign_quote.value = amount_to_assign.value - already_assigned.value

    project_id.value = select.value.projects_with_preselected.find(c => c?.is_preselected == 1)?.value || null
})

// -----------------------------------------------------

const cancelImport = () => {
    isQuoteAssignModalOpen.value = false
}
// -----------------------------------------------------

const makeImport = async () => {
    isLoading.value = true

    useForm({ statement_id: props.formData.id, project_id: project_id.value, assign_quote: assign_quote.value, already_assigned: already_assigned.value, amount_to_assign: amount_to_assign.value }).post(route('statement-quote-assign'), {
        preserveState: true,
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            if (page.props?.flash?.message) {
                screenMessage({ success: true, message: page.props.flash.message })
            }
            if (props.formData.refreshFn) {
                props.formData.refreshFn()
            }
            isLoading.value = false
            isQuoteAssignModalOpen.value = false
        },
        onError: (errors) => {
            isLoading.value = false
            onErrorService(errors, 'assign-form')
        },
        onFinish: () => {
            isLoading.value = false
        }
    })
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
